@if (isDialog) {
  <div class="dialog-actions">
    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" class="dialog-close" mat-mini-fab aria-label="Close Sidebar"
        >
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }
  </div>
}
@if (initialized) {
  @if (!smt?.id) {
    <app-site-material-test-create [smt]="smt" [site]="site"
    (dataChange)="onSMTChange($event)"></app-site-material-test-create>
  }
  <!-- Summary view -->
  @if (smt.id) {
    <mat-accordion>
      <!-- Draft -->
      @if (smt.status === 'draft') {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div class="panel-header">
              <div class="panel-title">Request</div>
              <div class="mat-body">Draft</div>
            </div>
          </mat-expansion-panel-header>
          <div>
            <div class="mat-body">From {{smt.createdBy?.name}}</div>
            <div class="mat-caption">{{smt.created_at | dateFormat: 'very-long'}}</div>
            <app-site-material-test-create class="stroked-card" editable="true" [smt]="smt"
            [site]="site" (dataChange)="onSMTChange($event)"></app-site-material-test-create>
          </div>
        </mat-expansion-panel>
      }
      <!-- /Draft -->
      <!-- Test Request -->
      @if (activity.sent_to_lab) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div class="panel-header">
              <div class="panel-title">Request</div>
              @if (activity.sent_to_lab) {
                <div class="mat-body">
                  {{activity.sent_to_lab.created_at | dateFormat: 'ago'}} ago
                </div>
              }
            </div>
          </mat-expansion-panel-header>
          @if (activity.sent_to_lab) {
            <div>
              <div class="mat-body">From {{activity.sent_to_lab.createdBy?.name}}</div>
              <div class="mat-caption">{{activity.sent_to_lab.created_at | dateFormat: 'very-long'}}</div>
              <app-site-material-test-create class="stroked-card" editable="false" [smt]="smt"
              [site]="site" (dataChange)="onSMTChange($event)"></app-site-material-test-create>
            </div>
          }
        </mat-expansion-panel>
      }
      <!-- Test Request -->
      <!-- Schedule -->
      <mat-expansion-panel [disabled]="!activity.sent_to_lab">
        <mat-expansion-panel-header>
          <div class="panel-header" [class.disabled]="!activity.sent_to_lab">
            <div class="panel-title">Schedule</div>
            <div class="mat-body">
              @if (!activity.lab_scheduled) {
                Test request received
              }
              @if (activity.lab_scheduled) {
                {{smt.request_date | dateFormat: 'very-long'}}
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <div class="schedule-block">
          <div class="stroked-card">
            <div class="label">Lab contacts:</div>
            <div class="details">
              <div class="details-row">{{ smt.lab?.email }}</div>
              <div class="details-row">{{ smt.lab?.phone }}</div>
            </div>
            <div class="label">Received on:</div>
            <div class="details">
              <div class="details-row">{{ smt.lab?.email }}</div>
            </div>
            @if (smt.status == 'sent_to_lab') {
              <div
                class="actions-section"
                >
                <button mat-flat-button
                  color="primary"
                  (click)="acceptLabSchedule(smt)">Accept schedule
                </button>
              </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
      <!-- /Schedule -->
      <!-- Record lab activity -->
      <mat-expansion-panel [disabled]="!activity.lab_scheduled">
        <mat-expansion-panel-header>
          <div class="panel-header" [class.disabled]="!activity.lab_scheduled">
            <div class="panel-title">Record</div>
            <div class="mat-body">
              @if (!activity.lab_activity_completed) {
                Fill in details
              }
              @if (activity.lab_activity_completed) {
                Visit details saved
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <div>
          @if (activity.lab_activity_completed) {
            <app-smt-record
              class="stroked-card"
              [smt]="smt"
              [editable]="false"
              (dataChange)="onSMTChange($event)"
            ></app-smt-record>
          }
          @if (!activity.lab_activity_completed) {
            <app-smt-record
              class="stroked-card"
              [smt]="smt"
              [editable]="true"
              (dataChange)="onSMTChange($event)"
            ></app-smt-record>
          }
        </div>
      </mat-expansion-panel>
      <!-- /Record lab activity -->
      <!-- Test Report -->
      <mat-expansion-panel [disabled]="!activity.lab_activity_completed">
        <mat-expansion-panel-header>
          <div class="panel-header" [class.disabled]="!activity.lab_activity_completed">
            <div class="panel-title">Report</div>
            <div class="mat-body">
              @if (!activity.updated_report) {
                Waiting for lab report
              }
              @if (activity.updated_report) {
                Lab report uploaded
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <div>
          @if (smt.material_test_reports?.length > 0) {
            <div class="cards-container">
              @for (report of smt.material_test_reports; track report.id) {
                <app-smt-report
                  class="stroked-card"
                  [smt]="smt"
                  [report]="report"
                  [editable]="false"
                  (dataChange)="onSMTChange($event)"
                ></app-smt-report>
              }
            </div>
          } @else {
            @if (activity.updated_report) {
              <app-smt-report
                class="stroked-card"
                [smt]="smt"
                [editable]="false"
                (dataChange)="onSMTChange($event)"
              ></app-smt-report>
            }
            @if (!activity.updated_report) {
              <app-smt-report
                class="stroked-card"
                [smt]="smt"
                [editable]="true"
                (dataChange)="onSMTChange($event)"
              ></app-smt-report>
            }
          }
        </div>
      </mat-expansion-panel>
      <!-- /Test Report -->
      <!-- Result -->
      <mat-expansion-panel [disabled]="!activity.updated_report">
        <mat-expansion-panel-header>
          <div class="panel-header" [class.disabled]="!activity.updated_report">
            <div class="panel-title">Result</div>
            <div class="mat-body">
              @if (!activity.passed && !activity.failed) {
                Waiting for result
              }
              @if (activity.passed) {
                Passed
              }
              @if (activity.failed) {
                Failed
              }
            </div>
          </div>
        </mat-expansion-panel-header>
        <div>
          @if (activity.passed || activity.failed) {
            <app-smt-result
              class="stroked-card"
              [smt]="smt"
              [editable]="false"
              (dataChange)="onSMTChange($event)"
            ></app-smt-result>
          }
          @if (!activity.passed && !activity.failed) {
            <app-smt-result
              class="stroked-card"
              [smt]="smt"
              [editable]="true"
              (dataChange)="onSMTChange($event)"
            ></app-smt-result>
          }
        </div>
      </mat-expansion-panel>
      <!-- /Result -->
    </mat-accordion>
  }
  <!-- /Summary view -->
}
